export interface LayoutSolutionAgencyConfiguration {
  agency: string;
  showSearchBar: boolean;
  subAgencies: string[];
}

export interface LayoutSolutionRequest {
  agency: string;
  includeSubAgencies: boolean;
  layout: string;
  withSearchbar: boolean;
}

export interface TrackingData {
  eventAction: string;
  eventLabel: string;
  contentLanguage?: string;
}

export enum Stage {
  Prod = 'prod',
  Test = 'test',
  Mr = 'mr',
  Cypress = 'cypress',
}

export interface FavouritesListItem {
  itemId: string;
  text: string;
}

export interface FavouritesList {
  identifier: string;
  userId: string;
  listName: string;
  listItems: FavouritesListItem[];
  createdAt: number;
  updatedAt: number;
}
